import React, { FC } from 'react';
import { IConsents, consentPopupsEvents } from '../types';
import Styles from './styles';
import { IConfig } from '../../../types/config';
import { cookies, routing } from '../../../translates';
import parse from 'html-react-parser';

const CookiesPopup: FC<{ setCookie: (consents: IConsents) => void; config: IConfig; language: string }> = ({
  setCookie,
  config,
  language,
}) => (
  <Styles config={config.general.content} cookies={config.cookies}>
    <div className={`cookies-popup`}>
      <div className={`cookies-popup-wrapper`}>
        <div className={`cookies-popup-container container`}>
          <div className={`cookies-popup-content`}>
            <div className={`cookies-popup-content-description`}>
              <p className="subtitle">{cookies[language].popupHeader}</p>
              <p>{parse(cookies[language].popupParagraphFirst)}</p>
              <p>{parse(cookies[language].popupParagraphSecond)}</p>
            </div>
          </div>
          <div className={`cookies-popup-buttons`}>
            <button
              className={`cookies-popup-buttons-button config`}
              onClick={() =>
                window.postMessage({ eventName: consentPopupsEvents.OPENCONFIGPOPUP }, window.location.origin)
              }
            >
              {cookies[language].popupSettings}
            </button>
            <button
              className={`cookies-popup-buttons-button reject`}
              onClick={() =>
                setCookie({
                  ad_storage: 'denied',
                  ad_user_data: 'denied',
                  ad_personalization: 'denied',
                  analytics_storage: 'denied',
                  functionality_storage: 'granted',
                  personalization_storage: 'denied',
                  security_storage: 'granted',
                })
              }
            >
              {cookies[language].popupReject}
            </button>
            <button
              className={`cookies-popup-buttons-button accept`}
              onClick={() =>
                setCookie({
                  ad_storage: 'granted',
                  ad_user_data: 'granted',
                  ad_personalization: 'granted',
                  analytics_storage: 'granted',
                  functionality_storage: 'granted',
                  personalization_storage: 'granted',
                  security_storage: 'granted',
                })
              }
            >
              {cookies[language].popupAccept}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Styles>
);

export default CookiesPopup;
